import {useState} from 'react';
import {Input, Form, Switch, Radio} from 'antd';
import styles from './founderCard.module.scss';
import trash from 'images/trash-can-outline.png';
import UploadImage from 'components/Startup/profile/companyImage';
import {Button} from '@dabafinance/react-components';
import DBModal from 'components/modal/modal';
import './switch.scss';
import {
  CREATE_COMPANY_TEAM_MEMBER,
  DELETE_COMPANY_TEAM_MEMBER,
  UPDATE_COMPANY_FOUNDER,
} from 'graphql/mutations/companyStartups';
import {GET_COMPANY_BY_ADMIN} from 'graphql/queries/startupCompanies';
import {useMutation} from '@apollo/client';
import {toast} from 'react-toastify';
import {useParams} from 'react-router-dom';

const FounderCard = ({
  teamId,
  name,
  edit,
  description,
  linkedin,
  role,
  sex,
  CEO,
  image,
  twitter,
  cardsRef,
  index,
}) => {
  const {TextArea} = Input;
  const [imgUrl, setImgUrl] = useState(image || '');
  const [fullname, setFullname] = useState(name);
  const {id} = useParams();
  const [previewUrl, setPreviewUrl] = useState(image || '');
  const [isCEO, setIsCEO] = useState(CEO || false);
  const [jobTitle, setJobTitle] = useState(role);
  const [aboutMember, setAboutMember] = useState(description || '');
  const [gender, setGender] = useState(sex || '');
  const [linkedinUrl, setLinkedinUrl] = useState(linkedin || '');
  const [twitterUrl, setTwitterUrl] = useState(twitter || '');
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [teamMemberId, setTeamMemberId] = useState('');
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [updateCompanyTeamMember, {loading: updating}] = useMutation(
    UPDATE_COMPANY_FOUNDER,
  );
  const [createCompanyTeamMember] = useMutation(CREATE_COMPANY_TEAM_MEMBER);
  const [deleteCompanyTeamMember, {loading: deleting}] = useMutation(
    DELETE_COMPANY_TEAM_MEMBER,
  );

  // Returns a promise that resolves to true on success / false on failure so
  // the parent "Finish" flow can await and know whether it's safe to leave.
  const handleSubmit = () => {
    if (!fullname || !jobTitle) {
      toast.error('Full name and job title are required');
      return Promise.resolve(false);
    }
    const optionalFields = {};
    if (twitterUrl) optionalFields.twitterUrl = twitterUrl;
    if (linkedinUrl) optionalFields.linkedinUrl = linkedinUrl;
    if (imgUrl) optionalFields.displayImage = imgUrl;
    if (aboutMember) optionalFields.description = aboutMember;
    if (gender) optionalFields.sex = gender;
    return createCompanyTeamMember({
      variables: {
        input: {
          companyId: id,
          name: fullname,
          role: jobTitle,
          isCEO,
          ...optionalFields,
        },
      },
    })
      .then(({data: {createCompanyTeamMember}}) => {
        if (createCompanyTeamMember.__typename === 'Error') {
          toast.error(createCompanyTeamMember.message);
          return false;
        }
        toast.success('Saved Successfully');
        setTeamMemberId(createCompanyTeamMember.id);
        setBtnDisabled(true);
        return true;
      })
      .catch(error => {
        toast.error(error);
        return false;
      });
  };

  const handleDeleteFounder = () => {
    deleteCompanyTeamMember({
      variables: {
        teamMemberId: edit ? teamId : teamMemberId,
        companyId: id,
      },
      refetchQueries: [
        {query: GET_COMPANY_BY_ADMIN, variables: {companyId: id}},
      ],
      awaitRefetchQueries: true,
    })
      .then(({data: {deleteCompanyTeamMember}}) => {
        if (deleteCompanyTeamMember.__typename === 'Error') {
          toast.error(
            deleteCompanyTeamMember.message || 'Something went wrong',
          );
        } else {
          toast.success('Deleted Successfully');
          setOpenDeleteModal(false);
        }
      })
      .catch(error => {
        toast.error(error.message);
      });
  };

  const handleEdit = () => {
    if (!fullname || !jobTitle) {
      return toast.error('Full name and job title are required');
    }
    const optionalFields = {};
    if (twitterUrl) optionalFields.twitterUrl = twitterUrl;
    if (linkedinUrl) optionalFields.linkedinUrl = linkedinUrl;
    if (imgUrl) optionalFields.displayImage = imgUrl;
    if (aboutMember) optionalFields.description = aboutMember;
    if (gender) optionalFields.sex = gender;
    updateCompanyTeamMember({
      variables: {
        input: {
          companyTeamMemberId: teamId,
          companyId: id,
          name: fullname,
          role: jobTitle,
          isCEO,
          ...optionalFields,
        },
      },
      refetchQueries: [
        {query: GET_COMPANY_BY_ADMIN, variables: {companyId: id}},
      ],
      awaitRefetchQueries: true,
    })
      .then(({data: {updateCompanyTeamMember}}) => {
        if (updateCompanyTeamMember.__typename === 'Error') {
          toast.error(updateCompanyTeamMember.message);
        } else {
          toast.success('Updated Successfully');
          setOpenConfirmModal(false);
        }
      })
      .catch(error => {
        toast.error(error.message);
      });
  };

  const options = [
    {label: 'Male', value: 'MALE'},
    {label: 'Female', value: 'FEMALE'},
  ];

  // Expose this card's live save state to the parent wizard so "Finish" can
  // persist filled-but-unsaved members. Only relevant for create-mode cards.
  if (!edit && cardsRef && typeof index === 'number') {
    cardsRef.current[index] = {
      saved: btnDisabled,
      canSave: Boolean(fullname && jobTitle),
      hasData: Boolean(
        fullname ||
          jobTitle ||
          aboutMember ||
          twitterUrl ||
          linkedinUrl ||
          imgUrl ||
          gender,
      ),
      save: handleSubmit,
    };
  }

  return (
    <div className={styles['card-container']}>
      <div className={styles['left-grid']}>
        <UploadImage
          previewUrl={previewUrl}
          setPreviewUrl={setPreviewUrl}
          setImgUrl={setImgUrl}
          bucket="company-service-bucket"
        />
        <div style={{height: 100}} />
      </div>
      <div className={styles['right-grid']}>
        <Form layout="vertical">
          <div className={styles.form}>
            <div className={styles['input-width']}>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: 'Member name is required',
                  },
                ]}
                label="Full Name">
                <Input
                  defaultValue={name}
                  value={fullname}
                  style={{width: 300}}
                  onChange={e => setFullname(e.target.value)}
                  placeholder="Courtney Henry"
                />
              </Form.Item>
            </div>
            <div className={styles['input-width']}>
              <Form.Item
                label="Job Title"
                className={styles['form-item']}
                rules={[
                  {
                    required: true,
                    message: 'Member Job title is Required',
                  },
                ]}>
                <Input
                  className={styles.date}
                  style={{width: 300}}
                  onChange={e => setJobTitle(e.target.value)}
                  value={jobTitle}
                  defaultValue={role}
                  placeholder={'CTO'}
                />
              </Form.Item>
            </div>
            <div className={styles['input-width']}>
              <Form.Item label="Twitter" name="twitter">
                <Input
                  defaultValue={twitter}
                  onChange={e => setTwitterUrl(e.target.value)}
                  value={twitterUrl}
                  style={{width: 300}}
                  placeholder="https://twitter.com"
                />
              </Form.Item>
            </div>
            <div className={styles['input-width']}>
              <Form.Item label="Linkedin">
                <Input
                  style={{width: 300}}
                  onChange={e => setLinkedinUrl(e.target.value)}
                  value={linkedinUrl}
                  defaultValue={linkedin}
                  placeholder="https://linkedin.com"
                />
              </Form.Item>
            </div>
            <div className={styles['founder-ceo']}>
              <div className={styles['founder-status']}>
                <Form.Item label="CEO">
                  <Switch defaultChecked={CEO} onChange={e => setIsCEO(e)} />
                </Form.Item>
                <Form.Item label="Sex" name="sex">
                  <Radio.Group
                    value={gender}
                    onChange={e => setGender(e.target.value)}
                    defaultValue={sex}
                    options={options}
                    optionType="button"
                  />
                </Form.Item>
              </div>
              <div className={styles['text-area-width']}>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: 'Description of member is required',
                    },
                  ]}
                  label="Member Description">
                  <TextArea
                    style={{width: 500}}
                    value={aboutMember}
                    defaultValue={description}
                    onChange={e => setAboutMember(e.target.value)}
                    rows={6}
                  />
                </Form.Item>
              </div>
            </div>
          </div>
          <div className={styles['delete-button']}>
            {edit ? (
              <Button
                type="secondary"
                className={styles.button}
                label={'Update'}
                onClick={() => setOpenConfirmModal(true)}
              />
            ) : (
              <Button
                type="secondary"
                disabled={btnDisabled}
                className={styles.button}
                label={btnDisabled ? 'Saved ✓' : 'Save member'}
                onClick={handleSubmit}
              />
            )}
            {edit && (
              <div onClick={() => setOpenDeleteModal(true)}>
                <img src={trash} alt="trash" />
                <span>Remove Member</span>
              </div>
            )}
          </div>
        </Form>
      </div>
      <DBModal
        isOpen={openConfirmModal}
        handleClose={() => setOpenConfirmModal(false)}
        content={
          <div className={styles['confirm-modal']}>
            <h1 className={styles['confirm-title']}>Update Member</h1>
            <p className={styles['confirm-text']}>
              Are you sure you want to update {fullname || 'this member'}&apos;s
              details?
            </p>
            <div className={styles['confirm-actions']}>
              <Button
                type="secondary"
                label="Cancel"
                onClick={() => setOpenConfirmModal(false)}
              />
              <Button
                label="Yes, Update"
                disabled={updating}
                onClick={handleEdit}
              />
            </div>
          </div>
        }
      />
      <DBModal
        isOpen={openDeleteModal}
        handleClose={() => setOpenDeleteModal(false)}
        content={
          <div className={styles['confirm-modal']}>
            <h1 className={styles['confirm-title']}>Remove Member</h1>
            <p className={styles['confirm-text']}>
              Are you sure you want to remove {fullname || 'this member'}? This
              action cannot be undone.
            </p>
            <div className={styles['confirm-actions']}>
              <Button
                type="secondary"
                label="Cancel"
                onClick={() => setOpenDeleteModal(false)}
              />
              <Button
                label="Yes, Remove"
                disabled={deleting}
                onClick={handleDeleteFounder}
              />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default FounderCard;
